import { DefaultLoadable } from '@apoly-42/material-ui';

const LoadChangeUserDataPage = DefaultLoadable({
  loader: () => import('./ChangeUserDataPage'),
});

export default LoadChangeUserDataPage;
